import { render, staticRenderFns } from "./ReportsView.vue?vue&type=template&id=0cb44c26&scoped=true&"
import script from "./ReportsView.vue?vue&type=script&lang=js&"
export * from "./ReportsView.vue?vue&type=script&lang=js&"
import style0 from "./ReportsView.vue?vue&type=style&index=0&id=0cb44c26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb44c26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
installComponents(component, {
  VIcon,
  VTab,
  VTabs,
  VToolbar,
})
